var React = require('react');

function IconLeftArrowSlider (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.0019 9.01408C20.0019 9.27449 19.9017 9.52488 19.7113 9.7252L13.4095 16.005L19.7013 22.2948C20.092 22.6854 20.092 23.3164 19.7013 23.707C19.3106 24.0977 18.6794 24.0977 18.2887 23.707L11.2855 16.7061C10.9048 16.3255 10.9048 15.6645 11.2855 15.2939L18.2887 8.29296C18.6794 7.90235 19.3106 7.90235 19.7013 8.29296C19.9017 8.50329 20.0019 8.75368 20.0019 9.01408Z"}));
}

IconLeftArrowSlider.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = IconLeftArrowSlider;

IconLeftArrowSlider.default = IconLeftArrowSlider;
